<template>
  <div class="slider">
    <vue-slider ref="slider" v-model="model" v-bind="props">
      <div class="slider-value" slot="tooltip" slot-scope="{ value }">
        <div class="slider-thumb" v-html="svg"></div>
        <div class="slider-label" :style="{ fontSize: (value >= max ? 14 : 16) + 'px' }">
          <small>{{ value === model[1] ? 'max' : 'min' }}</small><br>
          <small v-if="value < max">&euro; </small>{{ value >= max ? '>€' + (max - step) : value }}
        </div>
      </div>
    </vue-slider>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component'

export default {
  props: {
    disabled: null,
    input: null,
    value: null
  },
  components: {
    vueSlider
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (v) {
        if (this.input.model === 'budget' && v[1] < 10) {
          v = [v[0], 10]
          this.$refs.slider.setValue(v)
        }
        this.$emit('input', v)
      }
    },
    props () {
      return Object.assign({}, this.input, {
        disabled: this.disabled,
        interval: this.step,
        max: this.max,
        tooltipMerge: false,
        height: 4,
        width: '95%'
      })
    },
    svg() {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="48" height="92"><path fill="#fff" d="M41 40.5C37.5 44 25.5 53.1 25.5 63.8v4.5c0 4.5 3.8 7.5 4.9 8.5a8.8 8.8 0 0 1 2.6 6.3c0 5-4 8.9-9 8.9s-9-4-9-8.9c0-2.5 1-4.7 2.6-6.3 1-1 4.9-4 4.9-8.5v-4.5c0-10.7-12-19.9-15.5-23.3-4.3-4.3-7-10.2-7-16.8A23.9 23.9 0 0 1 24 0c13.3 0 24 10.6 24 23.7 0 6.6-2.7 12.5-7 16.8z"/></svg>'
    },
    max() {
      return this.input.max || 100
    },
    step() {
      return this.input.step || 1
    }
  }
}
</script>

<style>
.slider {
  margin: 0 20px;
}
@media (max-width: 399px) {
  .slider {
    margin: 0 30px 0 60px;
  }
}
.slider-value {
  width: 50px;
  height: 66px;
  font-size: 14px;
  text-align: center;
  color: #005ba9;
}
.slider-thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 48px;
  height: 92px;
}
.slider-thumb > svg {
  display: block;
  width: 48px;
  height: 92px;
  -webkit-filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.3));
}
.slider-label {
  position: relative;
  z-index: 1;
  padding-top: 7px;
  line-height: 14px;
}
.slider-label>small {
  font-size: 12px;
}

.vue-slider-component {
  padding-top: 76px!important;
  padding-bottom: 20px!important;
}
.vue-slider-component .vue-slider {
  background: rgba(255, 255, 255, .3)!important;
}
.vue-slider-component .vue-slider-process {
  background: white!important;
}
.vue-slider-component .vue-slider-dot {
  background: none!important;
  box-shadow: none!important;
}
</style>
